<template>
    <span :class="['mc-status', 'mc-status--' + tone]">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path v-for="(d, i) in paths" :key="i" :d="d" /></svg>{{ label }}
    </span>
</template>
<script>
// Stato sintetico con icona + parola. Il colore non è mai l'unico segnale.
const PATHS = {
    up: ["m3 17 6-6 4 4 8-8", "M14 7h7v7"],
    down: ["m3 7 6 6 4-4 8 8", "M14 17h7v-7"],
    alert: ["M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z", "M12 9v4M12 17h.01"],
    minus: ["M4 12h16"],
    info: ["M12 8h.01", "M11 12h1v5h1"],
    check: ["m5 12 5 5 9-10"],
    clock: ["M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18", "M12 7v5l3 2"],
};
// Icona di default per tono; per stati di processo passare icon="check" (completata) o "clock" (in attesa).
const DEFAULT_ICON = { good: "up", bad: "down", warn: "alert", neutral: "minus", info: "info" };
export default {
    name: "McStatusChip",
    props: {
        tone: { type: String, default: "neutral", validator: (v) => v in DEFAULT_ICON },
        label: { type: String, required: true },
        icon: { type: String, default: "", validator: (v) => !v || v in PATHS },
    },
    computed: { paths() { return PATHS[this.icon || DEFAULT_ICON[this.tone]]; } },
};
</script>
